import useFetchService from '@/composables/useFetchService';

export default function useMagazineService() {
  /********************
   * COMPOSITIONS      *
   ********************/
  const runtimeConfig = useRuntimeConfig();

  /********************
   * FUNCTIONS         *
   ********************/
  function getLatest(lang: string) {
    const baseUrl = runtimeConfig.public.magazineApiUrl.replace('{lang}', lang);
    const fetchService = useFetchService({ base: baseUrl, rewrite: false, attachClient: false });
    return fetchService.getPlain('');
  }

  return {
    getLatest,
  };
}
